import React, { Component } from "react";
import { Modal, Form, Row, Col, Button } from "antd";
import InputForm from "./InputForm";
import { checkFormIsValid } from '../utils/Validator';
import "./Form.css";

const { Item: ItemForm } = Form;

export const OPCOES_COR = [
  { key: '#FFFFFF', label: 'BRANCO', color: '#FFFFFF' },
  { key: '#E6E6E6', label: 'CINZA', color: '#E6E6E6' },
  { key: '#CEECF5', label: 'AZUL', color: '#CEECF5' },
  { key: '#81F7F3', label: 'CIAN', color: '#81F7F3' },
  { key: '#A9F5BC', label: 'VERDE', color: '#A9F5BC' },
  { key: '#F5A9A9', label: 'VERMELHO', color: '#F5A9A9' },
  { key: '#F5DA81', label: 'LARANJA', color: '#F5DA81' },
  { key: '#F5F6CE', label: 'AMARELO', color: '#F5F6CE' },
]

export default class StatusVendaForm extends Component {
  state = {
    registro: {
      sv_idf: '',
      sv_descricao: '',
      sv_cor: { key: '#FFFFFF', label: "" }
    },
    sv_cor: { key: '#FFFFFF', label: "" }
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado,
        sv_cor: { key: this.props.registroSelecionado.sv_cor.key, label: "" }
      }, () => {
        this.refs.sv_descricao.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    const { registro } = this.state;
    registro[id] = value;

    this.setState({
      [id]: value
    });
  };

  onOK = () => {
    if ((!this.state.registro.sv_descricao) || (this.state.registro.sv_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição' });
      return;
    }
    if (!this.state.registro.sv_idf) {
      if ((this.state.registro.sv_descricao.toUpperCase() === 'GERADA') || (this.state.registro.sv_descricao.toUpperCase() === 'RECEBIDA') || (this.state.registro.sv_descricao.toUpperCase() === 'SINCRONIZADA') || (this.state.registro.sv_descricao.toUpperCase() === 'ORÇAMENTO') || (this.state.registro.sv_descricao.toUpperCase() === 'REVISAR') || (this.state.registro.sv_descricao.toUpperCase() === 'BLOQUEADA')) {
        Modal.warning({ title: 'Aviso!', content: 'Descrição não permitida' });
        return;
      }
    }

    const reg = {
      sv_idf: this.state.registro.sv_idf,
      sv_descricao: this.state.registro.sv_descricao,
      sv_abrev: this.state.registro.sv_abrev,
      sv_cor: this.state.registro.sv_cor.key,
    }

    this.props.onSalvarClick(reg);
  };

  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { sv_idf, sv_descricao, sv_abrev, sv_cor } = this.state.registro;

    return (
      <Modal
        title={sv_idf ? "Edição de Status da Venda" : "Cadastro de Status da Venda"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"40%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24} sm={24}>
              <span>Descrição</span>
              <InputForm
                id="sv_descricao"
                ref="sv_descricao"
                maxLength={15}
                onChange={this.onChange}
                value={sv_descricao}
                validator={value => Boolean(value)}
                disabled={sv_descricao === 'GERADA' || sv_descricao === 'RECEBIDA' || sv_descricao === 'SINCRONIZADA' || sv_descricao === 'ORÇAMENTO' || sv_descricao === 'REVISAR' || sv_descricao === 'BLOQUEADA'}
              />
            </Col>
            <Col xs={24} sm={24} >
              <span>Cores</span>
              <InputForm
                type="select"
                id="sv_cor"
                ref="sv_cor"
                value={sv_cor}
                placeholder="Selecione"
                onChange={this.onChange}
                data={OPCOES_COR}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
              />
            </Col>
          </Row>
          <ItemForm>
            <Row>
              <Col xs={24}>
                 <Button
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="botoesModalForm"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StatusVendaForm.js